var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.product && !_vm.signedIn)?_c('div',{staticClass:"details-add-to-cart uk-margin-small-top",attrs:{"uk-grid":""}},[_c('div',{staticClass:"details-add-to-cart-button"},[_c('RequestPriceButton',{attrs:{"sku":_vm.sku,"size":"large"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }